<style lang="stylus" scoped>
    .recommend-page
        width 100%
        min-width 785px
        min-height 100%
        padding 24px 40px
        padding-bottom 0
        display flex
        flex-direction column
        .banner
            position relative
            width 100%
            height 214px
            z-index 2
            .bg
                width 100%
                height 100%
                pointer-events none
                user-select none
                img
                    width 100%
                    height 100%
                    border-radius 12px

            .search-box-wrapper
                position absolute
                left 50%
                top 32px
                width 100%
                max-width 720px
                transform translateX(-50%)
                z-index 1000

            .classbox
                position absolute
                top 101px
                left 50%
                max-width 865px
                width calc(100% - 220px)
                transform translateX(-50%)
                .scroll-control
                    position absolute
                    left 0
                    top 0
                    width 100%
                    .arrow
                        position absolute
                        display flex
                        justify-content center
                        align-items center
                        right -16px
                        top 12px
                        width 32px
                        height 32px
                        cursor pointer
                        border-radius 50%
                        background #fff
                        z-index 10
                        box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 10px 0px rgba(0, 0, 0, 0.08)
                        &:hover
                            background rgb(242,244,249)
                    .left-arrow
                        left -16px
                        right 0
                        img
                            transform rotate(180deg)
                .classlist
                    position relative
                    height 113px
                    display flex
                    column-gap 24px
                    overflow-x scroll
                    overflow-y visible
                    &::-webkit-scrollbar
                        display none
                    .class-splitline
                        display flex
                        align-items center
                        width 1px
                        height 48px
                        &::after
                            content ''
                            width 1px
                            height 16px
                            background #fff
                    .class-item
                        display flex
                        justify-content center
                        align-content space-between
                        flex-wrap wrap
                        width 72px
                        height 75px
                        cursor pointer
                        flex-shrink 0
                        &.active
                            .item-circle
                                background #fff
                                box-shadow 0px 2px 12px 0px #004C990D
                                .inner-circle
                                    border-color var(--themeColor)
                            .item-text
                                color #222
                                font-weight 700
                        .item-circle
                            width 54px
                            height 54px
                            padding 3px
                            margin-bottom 8px
                            border-radius 50%
                            background transparent
                            .inner-circle
                                display flex
                                justify-content center
                                align-items center
                                width 48px
                                height 48px
                                border 2px solid transparent
                                border-radius 50%
                                background #FFFFFFCC
                                box-shadow 0px 2px 12px 0px #004C990D
                                img
                                    width 32px
                                    height 32px
                        .item-text
                            width 100%
                            text-align center
                            font-size 12px
                            line-height 16px
                            color #000
                            display -webkit-box
                            -webkit-line-clamp 2
                            -webkit-box-orient vertical
                            overflow hidden
                            text-overflow ellipsis
                            word-break break-word
                    .select-icon
                        position absolute
                        bottom 0
                        left 21px
                .more-menu
                    position absolute
                    top 80px
                    width 210px
                    background #fff
                    border-radius 8px
                    box-shadow: 0px 4px 12px 0px #00000014;
                    .more-menu-list,.more-menu-sort
                        display flex
                        flex-wrap wrap
                        row-gap 4px
                        max-height 476px
                        padding 8px
                        @media screen and (max-width: 1366px)
                            max-height 260px
                        .more-menu-item
                            display flex
                            align-items center
                            column-gap 4px
                            height 32px
                            width 100%
                            padding 4px
                            border-radius 6px
                            cursor pointer
                            user-select none
                            img
                                width 24px
                                height 24px
                                flex-shrink 0
                            p
                                font-size 12px
                                color #222
                                textOverflow()
                            &:hover
                                background #3B55950D
                            &.active
                                background #017FFF14
                                p
                                    color var(--themeColor)
                        .more-menu-line
                            width 100%
                            height 1px
                            background: #00000014
                    .more-menu-sort
                        margin 0 8px 8px 8px
                        padding 0
</style>

<template>
    <ScrollView class="recommend-page-scroll">
        <div class="recommend-page">
            <div class="banner">
                <div class="bg">
                    <img src="@/home/assets/img/newPage/recommend-new/bg.png" alt="" />
                </div>

                <div class="search-box-wrapper">
                    <RecommendSearch />
                </div>

                <div class="classbox" :style="{ maxWidth: `${displayMaxWidth}px` }">
                    <div class="scroll-control">
                        <div class="arrow left-arrow" v-show="canscrollLeft" @click="scrollToLeft">
                            <img src="@/home/assets/img/newPage/recommend-new/right-arrow.svg" alt="" />
                        </div>
                        <div class="arrow" v-show="canscrollRight" @click="scrollToRight">
                            <img src="@/home/assets/img/newPage/recommend-new/right-arrow.svg" alt="" />
                        </div>
                    </div>
                    <div class="classlist" ref="classList">
                        <div class="class-item" :class="{ active: activeClassId == 0 }" @click="setActive(0)">
                            <div class="item-circle">
                                <div class="inner-circle">
                                    <img src="@/home/assets/img/newPage/recommend-new/menu01.png" alt="" />
                                </div>
                            </div>
                            <p class="item-text">{{ $t("recommendClass") }}</p>
                        </div>

                        <div class="class-splitline"></div>

                        <div
                            class="class-item"
                            v-for="item in displayClassList"
                            :key="item.class.id"
                            :class="{ active: activeClassId == item.class.id }"
                            @click="clickClass(item)"
                        >
                            <div class="item-circle">
                                <div class="inner-circle">
                                    <img :src="item.class.img_url" alt="" />
                                </div>
                            </div>
                            <p class="item-text" :title="lang == 'en' ? item.class.name : item.class['name_' + lang] || '-'">
                                {{ lang == "en" ? item.class.name : item.class["name_" + lang] || "-" }}
                            </p>
                        </div>

                        <div
                            class="class-item"
                            :class="{ active: activeClassId == moreActiveItem.class.id }"
                            v-if="moreActiveItem"
                            @click="clickClass(moreActiveItem)"
                        >
                            <div class="item-circle">
                                <div class="inner-circle">
                                    <img :src="moreActiveItem.class.img_url" alt="" />
                                </div>
                            </div>
                            <p class="item-text" :title="lang == 'en' ? moreActiveItem.class.name : moreActiveItem.class['name_' + lang] || '-'">
                                {{ lang == "en" ? moreActiveItem.class.name : moreActiveItem.class["name_" + lang] || "-" }}
                            </p>
                        </div>

                        <div class="class-item" ref="moreBtn" :class="{ active: activeClassId == 999 }" @click.stop="setActive(999)">
                            <div class="item-circle">
                                <div class="inner-circle">
                                    <img src="@/home/assets/img/newPage/recommend-new/menu-more.png" alt="" />
                                </div>
                            </div>
                            <p class="item-text">{{ $t("more") }}</p>
                        </div>

                        <img class="select-icon" ref="selectTrangle" src="@/home/assets/img/newPage/recommend-new/select.svg" alt="" />
                    </div>

                    <div class="more-menu" ref="moreMenu" v-if="showMoreMenu" v-click-outside="closeMoreMenu">
                        <ScrollView>
                            <div class="more-menu-list">
                                <div
                                    class="more-menu-item"
                                    :class="{ active: moreActiveItem && moreActiveItem.class.id == item.class.id }"
                                    v-for="item in menuClassList"
                                    :key="item.class.id"
                                    @click="clickMoreItem(item)"
                                >
                                    <img :src="item.class.img_url" alt="" />
                                    <p>{{ lang == "en" ? item.class.name : item.class["name_" + lang] || "-" }}</p>
                                </div>
                            </div>
                        </ScrollView>
                        <div class="more-menu-sort">
                            <div class="more-menu-line"></div>
                            <div class="more-menu-item" @click="showOrder">
                                <img src="@/home/assets/img/newPage/recommend-new/sort.svg" alt="" />
                                <p>{{ $t("sort") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <RecommendLv2
                ref="recommendLv2"
                v-if="![0, 999].includes(activeClassId)"
                :title="lv1Name"
                :list="lv2"
                @clickLv2="clickLv2"
                @resetLv2="resetLv2"
            />

            <RecommendFeature v-if="activeClassId == 0 || activeClassId == 999" />

            <RecommendTemplate
                :list="displayTemplateList"
                :emptyText="emptyText"
                :lv2Libs="lv2Libs"
                :diagramTypeForTrack="diagramTypeForTrack"
                :templateClass="templateClass"
                :nameForStore="nameForStore"
                :showBottom="true"
                @nextPage="nextPage"
            />

            <ListOrder v-if="showOrderModal" @closeModal="closeModal" :list="classList" @changeList="changeOrderList"></ListOrder>

            <!-- <MoreTemplateDialog v-if="showMoreTemplate" @close="showMoreTemplate = false" /> -->
        </div>
    </ScrollView>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import throttle from "lodash.throttle";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import ListOrder from "./modal/ListOrder.vue";
    import RecommendTemplate from "./recommend-template.vue";
    import RecommendLv2 from "./recommend-lv2.vue";
    import RecommendFeature from "./recommend-feature.vue";
    import RecommendSearch from "./recommend-search.vue";

    @Component({
        components: {
            ScrollView,
            ListOrder,
            RecommendTemplate,
            RecommendLv2,
            RecommendFeature,
            RecommendSearch,
        },
    })
    export default class Recommend extends Vue {
        canScroll = false;
        canscrollLeft = false;
        canscrollRight = false;
        checkScroll() {
            let el = this.$refs.classList as HTMLElement;
            if (el) {
                this.canScroll = el.clientWidth != el.scrollWidth;
                this.canscrollLeft = el.scrollLeft > 1;
                this.canscrollRight = el.scrollWidth - el.scrollLeft - el.clientWidth > 1;
            }
        }
        scrollTo(position = 0) {
            let el = this.$refs.classList as HTMLElement;
            if (el) {
                const onScroll = (e) => {
                    if (Math.abs(el.scrollLeft - position) < 1) {
                        this.checkScroll();
                        el.removeEventListener("scroll", onScroll);
                    }
                };
                el.addEventListener("scroll", onScroll);
                el.scrollTo({
                    behavior: "smooth",
                    left: position,
                });
            }
        }
        scrollToRight() {
            let el = this.$refs.classList as HTMLElement;
            if (el) {
                const maxLeft = el.scrollWidth - el.clientWidth;
                let left = el.scrollLeft + 300;
                left = left < maxLeft ? left : maxLeft;
                this.scrollTo(left);
            }
        }
        scrollToLeft() {
            let el = this.$refs.classList as HTMLElement;
            if (el) {
                let left = el.scrollLeft - 300;
                left = left > 0 ? left : 0;
                this.scrollTo(left);
            }
        }
        resetScroll() {
            let el = this.$refs.classList as HTMLElement;
            el &&
                el.scrollTo({
                    left: 0,
                });
            this.canScroll = false;
            this.canscrollLeft = false;
            this.canscrollRight = false;
            this.$nextTick(() => {
                this.checkScroll();
            });
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }
        @Watch("userInfo")
        userInfoChange(newVal, oldVal) {
            if (newVal?.user_id !== oldVal?.user_id) {
                this.initRecommendTemplate();
            }
        }

        // get list
        displayClassNum = 0;
        maxWidth = 865;
        get displayClassList() {
            return this.classList.slice(0, this.displayClassNum);
        }
        get menuClassList() {
            return this.classList.slice(this.displayClassNum, this.classList.length);
        }
        get displayMaxWidth() {
            return this.moreActiveItem ? this.maxWidth + 96 : this.maxWidth;
        }
        setDistplayClass() {
            const existMoreItem = this.displayClassList.findIndex((item) => {
                return this.moreActiveItem && item.class.id == this.moreActiveItem.class.id;
            });
            if (existMoreItem != -1) {
                this.moreActiveItem = null;
            }
            const width = window.innerWidth;
            if (width < 2100) {
                this.displayClassNum = 9 - 2;
            } else if (width < 2400) {
                this.displayClassNum = 10 - 2;
            } else if (width < 2500) {
                this.displayClassNum = 11 - 2;
            } else {
                this.displayClassNum = 13 - 2;
            }
            this.maxWidth = 96 * (this.displayClassNum + 2) + 1;
        }
        classList = [];
        initList() {
            this.$edApi.getRecommendClass({ user_id: this.userInfo?.user_id || 0 }).then((res) => {
                let order = this.loadOrderOption();
                let list = this.orderByList(res.data.data, order);
                list.forEach((item) => {
                    item.class.img_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${encodeURIComponent(item.class.img_url)}`;
                    return item;
                });
                this.classList = list;
                this.setDistplayClass();
                this.checkUrl();
                this.$nextTick(() => {
                    this.checkScroll();
                });
            });
        }
        checkUrl() {
            let url = new URLSearchParams(location.search);
            let diagram = url.get("diagram");
            let category = url.get("category");
            let flag = false;
            if (diagram) {
                let { _lv1, _lv2 } = this.toRecommend(diagram);
                flag = !!_lv1 && !!_lv2;
                if (flag) {
                    this.codeToView(_lv1, _lv2);
                }
            }
            if (category) {
                let { _lv1 } = this.toCategory(category);
                flag = !!_lv1;
                if (_lv1) {
                    this.codeToView(_lv1);
                }
            }
            return flag;
        }
        diagramMap = new Map([
            ["org-chart-automated", "Org Chart(Automated)"],
            ["electrical-and-telecom-plan", "Electrical and Telecom Plan"],
            ["process-pid", "Process P&ID"],
            ["design-and-education", "Design & Education"],
            ["uml-modeling", "UML timing diagram"],
        ]);
        toRecommend(targetStr = "") {
            targetStr = this.diagramMap.get(targetStr) || targetStr;
            targetStr = targetStr.replace(/\s|\-/g, "").toLowerCase();
            let list = this.classList;
            const fitStr = (str) => {
                str = str.replace(/\s|\-/g, "").toLowerCase();
                return str.indexOf(targetStr) != -1;
            };
            let _lv1 = null;
            let _lv2 = null;
            list: for (let i = 0; i < list.length; i++) {
                let lv2 = list[i].subclass;
                for (let j = 0; j < lv2.length; j++) {
                    let s = lv2[j].name;
                    if (fitStr(s)) {
                        _lv1 = list[i];
                        _lv2 = lv2[j];
                        break list;
                    }
                }
            }
            return {
                _lv1,
                _lv2,
            };
        }
        toCategory(targetStr) {
            let list = this.classList;
            targetStr = this.diagramMap.get(targetStr) || targetStr;
            let aContainb = (a, b) => {
                a = a.replace(/\s|\-/g, "").toLowerCase();
                b = b.replace(/\s|\-/g, "").toLowerCase();
                return a.indexOf(b) != -1;
            };
            let _lv1 = list.find((item) => aContainb(item.class.name, targetStr)) || null;
            return {
                _lv1,
            };
        }
        codeToView(lv1, subclass?) {
            const existItem = this.displayClassList.findIndex((item) => {
                return item.class.id == lv1.class.id;
            });
            if (existItem == -1) {
                this.moreActiveItem = lv1;
            }
            this.setActive(lv1.class.id);
            !subclass && this.getTemplateList(lv1.class.id, "class");
            this.lv2Name = "";
            this.tempLV2 = null;
            this.lv1Name = this.lang == "en" ? lv1.class.name : lv1.class["name_" + this.lang] || "-";
            this.tempLV1 = lv1;
            let lv2 = JSON.parse(JSON.stringify(lv1.subclass));
            this.lv2 = lv2.map((item) => {
                item.img_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${encodeURIComponent(item.img_url)}`;
                return item;
            });
            this.lv2Libs = null;
            this.diagramTypeForTrack = lv1.class.name;
            this.templateClassForTrack = [lv1.class.name, ""];

            if (subclass) {
                this.$nextTick(() => {
                    this.tempLV2 = subclass;
                    this.lv2Name = this.lang == "en" ? subclass.name : subclass["name_" + this.lang] || "-";
                    this.lv2Libs = subclass.libs;
                    this.diagramTypeForTrack = subclass.name;
                    this.templateClassForTrack.splice(1, 1, subclass.name);
                    (this.$refs.recommendLv2 as any).setLv2Id(subclass.id);
                    this.getTemplateList(subclass.id, "sub");
                });
            }
        }
        fitLangChange() {
            if (this.tempLV1) {
                this.lv1Name = this.lang == "en" ? this.tempLV1.class.name : this.tempLV1.class["name_" + this.lang] || "-";
            }
            if (this.tempLV2) {
                this.lv2Name = this.lang == "en" ? this.tempLV2.name : this.tempLV2["name_" + this.lang] || "-";
            }
        }
        // calcActiveNum() {
        //     let el = this.$refs.classList as HTMLElement;
        //     if (el) {
        //         let width = el.offsetWidth;
        //         const block = 72;
        //         const margin = 24;
        //         width -= block * 2 + 24 * 2 + 1;
        //         this.displayClassNum = Math.floor(width / (block + margin));
        //         console.log(this.displayClassNum);
        //     }
        // }
        get displayTemplateList() {
            if (this.activeClassId == 0) {
                return this.recommendList;
            } else {
                return this.templateList;
            }
            return [];
        }
        get emptyText() {
            // 控制是否显示新建空白文件
            if (this.activeClassId == 0) {
                return "";
            } else if (this.lv2Name) {
                return this.$t("newEmpty", { label: this.lv2Name });
            } else if (this.lv1Name) {
                return this.$t("newEmpty", { label: this.lv1Name });
            }
            return "";
        }
        get nameForStore() {
            // 控制是否显示新建空白文件
            if (this.activeClassId == 0) {
                return "";
            } else if (this.lv2Name) {
                return this.lv2Name;
            } else if (this.lv1Name) {
                return this.lv1Name;
            }
            return "";
        }
        get templateClass() {
            // 埋点数据
            if (this.activeClassId == 0) {
                return "recommend";
            } else if (this.templateClassForTrack[1] == "") {
                return `all_${this.templateClassForTrack[0]}`;
            } else {
                return `${this.templateClassForTrack[1]}`;
            }
        }
        recommendList = [];
        recommendPager = {
            offset: 0,
            count: 20,
            total: 0,
        };
        recommendLoading = false;
        getRecommendData(count, offset) {
            const handleResult = (res) => {
                if (res.data.data.list.length != 0) {
                    this.recommendList = this.recommendList.concat(
                        res.data.data.list.map((item) => {
                            item.img_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${encodeURIComponent(item.img_url)}`;
                            return item;
                        })
                    );
                }
                this.recommendPager.total = res.data.data.total;
            };
            if (this.userInfo?.user_id) {
                this.$edApi
                    .getRecommendTemplates({
                        id: this.userInfo.user_id,
                        token: this.userInfo.token,
                        pre_tpl_ids: [],
                        offset: offset,
                        count: count,
                    })
                    .then(handleResult)
                    .finally(() => {
                        this.recommendLoading = false;
                    });
            } else {
                this.$edApi
                    .getRecommendTemplatesNotLogin({
                        pre_tpl_ids: [],
                        offset: offset,
                        count: count,
                    })
                    .then(handleResult)
                    .finally(() => {
                        this.recommendLoading = false;
                    });
            }
        }
        initRecommendTemplate() {
            if (this.recommendLoading) return;
            this.recommendLoading = true;
            this.recommendList = [];
            this.recommendPager.offset = 0;
            this.recommendPager.total = 0;
            let firstPageCount = this.recommendPager.count;
            if (window.innerWidth > 1800) {
                let num = 1 + Math.floor(window.innerWidth / 1800);
                firstPageCount = num * this.recommendPager.count;
                this.recommendPager.offset += 20 * (num - 1);
            }
            this.getRecommendData(firstPageCount, 0);
        }
        templateList = [];
        getTemplateList(class_id, type) {
            this.templateList = [];
            this.$store.dispatch("getTemplate", { class_id, type }).then((res) => {
                if (res.data.data.length == 0) {
                    (<any>this).$edMessage.success(this.$t("notTem"));
                }
                let arr = res.data.data;
                arr.forEach((v) => {
                    v.img_url = window["GLOBAL"].PUBLIC_OSS_HOST + encodeURIComponent(v.img_url);
                });
                this.templateList = arr;
            });
        }
        nextRecommendPage() {
            if (this.recommendLoading || this.recommendList.length == this.recommendPager.total) return;
            this.recommendLoading = true;
            this.recommendPager.offset += 20;
            this.getRecommendData(this.recommendPager.count, this.recommendPager.offset);
        }

        diagramTypeForTrack = "";
        templateClassForTrack = ["", ""];
        activeClassId = 0;
        tempLV1 = null;
        clickClass(item) {
            this.tempLV1 = item;
            this.setActive(item.class.id);
            this.getTemplateList(item.class.id, "class");
            this.lv2Name = "";
            this.tempLV2 = null;
            this.lv1Name = this.lang == "en" ? item.class.name : item.class["name_" + this.lang] || "-";
            this.tempLV1 = item;
            let lv2 = JSON.parse(JSON.stringify(item.subclass));
            this.lv2 = lv2.map((item) => {
                item.img_url = `${window["GLOBAL"].PUBLIC_OSS_HOST}${encodeURIComponent(item.img_url)}`;
                return item;
            });
            this.lv2Libs = item.class.libs;
            this.diagramTypeForTrack = item.class.name;
            this.templateClassForTrack = [item.class.name, ""];

            this.sensors.track("FirstLevelCategoryClick", {
                Catalogues: "RecommendedTemplate",
                classification: item.class.name,
            });
        }
        setActive(id) {
            this.lv2Libs = null;
            if (id == 0) {
                this.sensors.track("FirstLevelCategoryClick", {
                    Catalogues: "RecommendedTemplate",
                    classification: "recommend",
                });
            } else if (id == 999) {
                this.expandMoreMenu();
                this.sensors.track("FirstLevelCategoryClick", {
                    Catalogues: "RecommendedTemplate",
                    classification: "more",
                });
                return;
            }
            this.activeClassId = id;
            this.$nextTick(() => {
                this.setSelectPosition();
            });
        }
        setSelectPosition() {
            let classList = this.$refs.classList as HTMLElement;
            let el = this.$refs.selectTrangle as HTMLElement;
            if (classList && el) {
                let find = false;
                for (let i = 0; i < classList.children.length; i++) {
                    let item = classList.children[i] as HTMLElement;
                    if (item.className.includes("active")) {
                        find = true;
                        el.style.left = `${item.offsetLeft + item.offsetWidth / 2 - 15}px`;
                    }
                }
                if (!find) {
                    let moreItem = this.$refs.moreBtn as HTMLElement;
                    el.style.left = `${moreItem.offsetLeft + moreItem.offsetWidth / 2 - 15}px`;
                }
            }
        }
        showMoreMenu = false;
        moreActiveItem = null;
        expandMoreMenu() {
            this.showMoreMenu = true;
            this.$nextTick(() => {
                this.setMoreMenuPosition();
            });
        }
        closeMoreMenu() {
            this.showMoreMenu = false;
        }
        setMoreMenuPosition() {
            let el = this.$refs.moreBtn as HTMLElement;
            let menu = this.$refs.moreMenu as HTMLElement;
            let classList = this.$refs.classList as HTMLElement;
            if (el && menu) {
                const selfOffset = window.innerWidth > 1520 ? 9 : -menu.offsetWidth + el.offsetWidth - 9;
                let left = el.offsetLeft - classList.scrollLeft + selfOffset;
                menu.style.left = `${left}px`;
            }
        }
        clickMoreItem(item) {
            this.moreActiveItem = item;
            this.closeMoreMenu();
            this.$nextTick(() => {
                this.checkScroll();
                this.clickClass(item);
            });
        }
        nextPage() {
            if (this.activeClassId == 0) {
                this.nextRecommendPage();
            }
        }

        // lv2
        lv1Name = "";
        lv2 = [];
        lv2Name = "";
        lv2Libs = null;
        tempLV2 = null;
        clickLv2(item) {
            this.tempLV2 = item;
            this.lv2Name = this.lang == "en" ? item.name : item["name_" + this.lang] || "-";
            this.lv2Libs = item.libs;
            this.diagramTypeForTrack = item.name;
            this.templateClassForTrack.splice(1, 1, item.name);
            this.getTemplateList(item.id, "sub");

            this.sensors.track("SecondLevelCategoryClick", {
                Catalogues: "RecommendedTemplate",
                classification: item.name,
            });
        }
        resetLv2() {
            let item = this.classList.find((item) => item.class.id == this.activeClassId);
            if (item) {
                this.getTemplateList(item.class.id, "class");
                this.lv2Libs = item.class.libs;
                this.diagramTypeForTrack = item.class.name;
                this.templateClassForTrack = [item.class.name, ""];
                this.lv2Name = "";
                this.tempLV2 = null;

                this.sensors.track("SecondLevelCategoryClick", {
                    Catalogues: "RecommendedTemplate",
                    classification: `all_${item.class.name}`,
                });
            }
        }

        // order
        showOrderModal = false;
        showOrder() {
            this.closeMoreMenu();
            this.showOrderModal = true;
            this.sensors.track("FirstLevelCategoryClick", {
                Catalogues: "RecommendedTemplate",
                classification: "Custom sorting",
            });
        }
        closeModal() {
            this.showOrderModal = false;
        }
        changeOrderList(data) {
            this.classList = data;
            this.saveOrderOption();
            this.setDistplayClass();
            this.$nextTick(() => {
                this.setSelectPosition();
            });
        }
        loadOrderOption() {
            let order = [];
            let local = localStorage.getItem("classOrder");
            if (local) {
                order = JSON.parse(local);
            }
            return order;
        }
        saveOrderOption() {
            let ids = this.classList.map((item) => item.class.id);
            localStorage.setItem("classOrder", JSON.stringify(ids));
        }
        orderByList(target, order) {
            target.sort((a, b) => {
                const aIndex = order.indexOf(a?.class.id);
                const bIndex = order.indexOf(b?.class.id);
                return aIndex - bIndex;
            });
            return target;
        }

        created() {
            this.initList();
            this.initRecommendTemplate();
            this.$bus.$on("refreshRecommend", () => {
                this.initList();
                this.initRecommendTemplate();
            });
        }
        mounted() {
            const resizeEvent = throttle(() => {
                this.setDistplayClass();
                this.$nextTick(() => {
                    this.checkScroll();
                    this.setSelectPosition();
                    this.setMoreMenuPosition();
                });
            }, 34);
            window.addEventListener("resize", resizeEvent);
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener("resize", resizeEvent);
            });
            this.$bus.$on("changeLangDone", this.fitLangChange);
        }
        beforeDestroy() {
            this.$bus.$off("refreshRecommend");
            this.$bus.$off("changeLangDone", this.fitLangChange);
        }
    }
</script>
<i18n>
    {
      "zh": {
        "free": "免费",
        "vipFree": "VIP专享",
        "newFile": "未命名文件",
        "space": "云空间已达上限， 删除文件或清理回收站",
        "notTem": "该分类下暂时还没有模板",
        "create": "正在创建文件中，请稍后再试",
        "search": "搜索",
        "searchResult": "搜索结果",
        "recent": "最近",
        "recommend": "推荐",
        "classify": "分类",
        "moreTemplate": "更多绘图类型",
        "createNow": "立即新建",
        "showTemplates": "查看模板",
        "template": "模板",
        "clone": "使用模板",
        "inputSearch": "搜索你需要的绘图",
        "searchHistory": "搜索历史",
        "clearHistory": "清空历史搜索",
        "recommendTemp": "推荐模板",
        "blank": "空白",
        "file": "文件",
        "aiTemplateTitle": "AI 功能",
        "aiTemplateDesc": "用AI加速你的工作",
        "aiTemplateDesc1": "用亿图AI加速你的工作",
        "aicreateflowchartDesc": "轻松创建流程图",
        "aiflowchart": "AI 流程图",
        "aimindmap": "AI 思维导图",
        "pictureAnalysis": "AI 图片分析",
        "aiQA": "AI 问答",
        "aiDraw": "AI 绘画",
        "aicreatemindmapDesc": "一键创建思维导图",
        "aiQADesc": "与亿图AI对话，加速你的思考",
        "aipictureAnalysisDesc":"图片分析用亿图AI轻松搞定",
        "aiDrawDesc": "AI绘图打开你的想象力",
        "newEmpty": "新建空白{label}",
        "recommendClass": "精选推荐",
        "more": "更多",
        "sort": "自定义排序",
        "input": "请输入"
      },
      "en": {
        "free": "Free",
        "vipFree": "Premium",
        "newFile": "Unnamed File",
        "space": "Space storage not enough, delete files or upgrade to premium version to solve it.",
        "notTem": "There is no template for this category yet.",
        "create": "Creating file, please try again later.",
        "openTips": "Opening file, please try again later.",
        "search": "Search",
        "searchResult": "searchResult",
        "recent": "Recent",
        "recommend": "Recommended",
        "classify": "Classification",
        "moreTemplate": "More Shapes",
        "createNow": "Create New",
        "template": "Template",
        "clone": "Use Template",
        "inputSearch": "Search drawings you need",
        "searchHistory": "Search history",
        "clearHistory": "Clear history",
        "recommendTemp": "Recommended Templates",
        "blank": "Blank",
        "file": "File",
        "aiTemplateTitle": "AI Tools",
        "aiTemplateDesc": "Using AI to accelerate your work",
        "aiTemplateDesc1": "Accelerate your workflow using Edraw AI",
        "aiflowchart": "AI Flowchart",
        "aimindmap": "AI Mindmap",
        "pictureAnalysis": "AI Picture Analysis",
        "aicreateflowchartDesc": "Chat to create flowchart  instantly",
        "aiQA": "AI Chat",
        "aiDraw": "AI Drawing",
        "aicreatemindmapDesc": "Create Mindmap with one click",
        "aiQADesc": "Chat with Edraw AI to get insight for work",
        "aipictureAnalysisDesc":"Analyze your picture easy with Edraw AI",
        "aiDrawDesc": "AI Drawing",
        "newEmpty": "New Blank {label}",
        "recommendClass": "For you",
        "more": "More",
        "sort": "Customize Orders",
        "input": "Please enter"
      },
      "fr": {
        "free": "Gratuit",
        "vipFree": "Premium",
        "newFile": "Fichier sans nom",
        "space": "L'espace cloud a atteint la limite supérieure, supprimer des fichiers ou nettoyer la corbeille",
        "notTem": "Il n'y a pas de modèle pour cette catégorie",
        "create": "Création du fichier, veuillez réessayer plus tard",
        "openTips": "Ouverture du fichier, veuillez réessayer plus tard",
        "search": "Chercher",
        "searchResult": "Résultat de la recherche",
        "recent": "Récent",
        "recommend": "Conseillé",
        "classify": "Classification",
        "moreTemplate": "Plus de modèles",
        "createNow": "Créer",
        "template": "Modèles",
        "inputSearch": "Recherchez les dessins dont vous avez besoin",
        "searchHistory": "Historique de recherche",
        "clearHistory": "Effacer l'historique",
        "moreTemplate": "Plus de formes",
        "recommendTemp": "Modèles recommandés",
        "blank": "Vide",
        "file": "Fichier",
        "aiTemplateTitle": "Outils d'IA",
        "aiTemplateDesc": "Utiliser l'IA pour travailler plus efficacement",
        "aiTemplateDesc1": "Accélérer votre workflow à l'aide d'Edraw IA",
        "aiflowchart": "Organigramme IA",
        "aimindmap": "Carte mentale par IA",
        "pictureAnalysis": "Analyse d'image par IA",
        "aicreateflowchartDesc": "Envoyer des messages pour créer un organigramme instantanément ",
        "aiQA": "Chat AI",
        "aiDraw": "Dessin AI",
        "aicreatemindmapDesc": "Créer une carte mentale en un seul clic  ",
        "aiQADesc": "Discuter avec Edraw IA afin d'obtenir des informations pour votre travail",
        "aipictureAnalysisDesc":"Analyser facilement votre image avec Edraw IA",
        "aiDrawDesc": "Dessin AI",
        "newEmpty": "Nouveau {label} vierge",
        "recommendClass": "Recommandé",
        "more": "Plus",
        "clone": "Utiliser le modèle",
        "sort": "Redéfinir l'ordre d'affichage",
        "input": "Veuillez entrer"
      },
      "de": {
        "free": "Kostenlos",
        "vipFree": "Premium",
        "newFile": "Unbenannte Datei",
        "space": "Speicherplatz nicht ausreichend, Dateien löschen oder auf Premium-Version aktualisieren, um das Problem zu lösen",
        "notTem": "Es gibt noch keine Vorlage für diese Kategorie",
        "create": " Datei wird erstellt, versuchen Sie es später erneut",
        "openTips": " Datei wird geöffnet, versuchen Sie es später erneut",
        "search": "Suchen",
        "searchResult": "Suchergebnis",
        "recent": "Letzte",
        "recommend": "Empfohlen",
        "classify": "Einstufung",
        "recommendNew": "Neue leere Zeichnung",
        "moreTemplate": "Mehr Vorlagen",
        "createNow": "Jetzt erstellen",
        "template": "Vorlagen",
        "inputSearch": "Nach benötigten Zeichnungen suchen",
        "searchHistory": "Suchverlauf",
        "clearHistory": "Verlauf löschen",
        "moreTemplate": "Mehr Formen",
        "recommendTemp": "Empfohlene Vorlagen",
        "blank": "Leer",
        "file": "Datei",
        "aiTemplateTitle": "AI Tools",
        "aiTemplateDesc": "AI zur Beschleunigung Ihrer Arbeit ",
        "aiTemplateDesc1": "Beschleunigen Sie Ihren Workflow mit Edraw AI",
        "aiflowchart": "AI Flussdiagramm",
        "aimindmap": "AI Mindmap",
        "pictureAnalysis": "AI Bildanalyse",
        "aicreateflowchartDesc": "Chatten, um ein Flussdiagramm sofort zu erstellen ",
        "aiQA": "AI Chat",
        "aiDraw": "AI Drawing",
        "aicreatemindmapDesc": "Eine Mindmap mit einem Klick erstellen  ",
        "aiQADesc": "Mit Edraw AI chatten, um Einblicke für die Arbeit zu erhalten",
        "aipictureAnalysisDesc":"Ein Bild ganz einfach mit Edraw AI analysieren",
        "aiDrawDesc": "AI Zeichnung",
        "newEmpty": "Neues leeres {label}",
        "recommendClass": "Empfohlen",
        "more": "Mehr",
        "clone": "Vorlage verwenden",
        "sort": "Reihenfolge neu anordnen",
        "input": "Bitte eingeben"
      },
      "jp": {
        "free": "無料",
        "vipFree": "プレミアム",
        "newFile": "名前のないファイル",
        "space": "クラウドスペースが上限に達した、ファイルを削除、またはごみ箱をクリーンアップしてください",
        "notTem": "このカテゴリにはテンプレートがありません",
        "create": "ファイルを作成しています。しばらくしてからもう一度お試しください",
        "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
        "search": "検索",
        "searchResult": "検索結果",
        "recent": "最近",
        "recommend": "おすすめ",
        "classify": "分類",
        "moreTemplate": "その他のテンプレート",
        "createNow": "今すぐ作成",
        "template": "テンプレート",
        "inputSearch": "必要な図表を検索",
        "searchHistory": "検索履歴",
        "clearHistory": "履歴をクリア",
        "moreTemplate": "その他の図形",
        "recommendTemp": "おすすめのテンプレート",
        "blank": "空白",
        "file": "ファイル",
        "aiTemplateTitle": "AIツール",
        "aiTemplateDesc": "AIで仕事の効率をアップ",
        "aiTemplateDesc1": "Edraw AIでワークフローを加速",
        "aiflowchart": "AIフローチャート",
        "aimindmap": "AIマインドマップ",
        "pictureAnalysis": "AI画像解析",
        "aicreateflowchartDesc": "チャットしてフローチャートを瞬時に作成 ",
        "aiQA": "AIチャット",
        "aiDraw": "AI描画",
        "aicreatemindmapDesc": "ワンクリックでマインドマップを作成  ",
        "aiQADesc": "Edraw AIとのチャットで仕事のヒントをつかむ",
        "aipictureAnalysisDesc":"Edraw AIで簡単に画像解析",
        "aiDrawDesc": "AI描画",
        "newEmpty": "新しい空の{label}",
        "recommendClass": "おすすめ",
        "more": "その他",
        "clone": "テンプレートを使用する",
        "sort": "順序を並べ替え",
        "input": "入力してください..."
      },
      "es": {
        "free": "Gratis",
        "vipFree": "Premium",
        "newFile": "Archivo sin nombre",
        "space": "El espacio de almacenamiento no es suficiente, elimine archivos o actualice a la versión premium para resolverlo",
        "notTem": "Todavía no hay una plantilla para esta categoría.",
        "create": "Creando archivo, por favor intente nuevamente más tarde.",
        "openTips": "Abrir archivo, por favor intente nuevamente más tarde.",
        "search": "Buscar",
        "searchResult": "Resultado de Búsqueda",
        "recent": "Reciente",
        "recommend": "Recomendado",
        "classify": "Clasificación",
        "moreTemplate": "Más plantillas",
        "createNow": "Crear ahora",
        "template": "Plantillas",
        "inputSearch": "Busca los dibujos que necesites",
        "searchHistory": "Historial de búsqueda",
        "clearHistory": "Borrar historial",
        "moreTemplate": "Más formas",
        "recommendTemp": "Plantillas recomendadas",
        "blank": "En blanco",
        "file": "Archivo",
        "aiTemplateTitle": "Herramientas de IA",
        "aiTemplateDesc": "Uso de la IA para acelerar el trabajo ",
        "aiTemplateDesc1": "Acelera tu flujo de trabajo con Edraw AI",
        "aiflowchart": "Diagrama de flujo con IA",
        "aimindmap": "Mapa mental con IA",
        "pictureAnalysis": "Análisis de imágenes con IA",
        "aicreateflowchartDesc": "Chatea para crear un diagrama de flujo al instante ",
        "aiQA": "Chat de AI",
        "aiDraw": "Dibujo de AI",
        "aicreatemindmapDesc": "Crea un mapa mental con un solo clic ",
        "aiQADesc": "Chatea con Edraw AI y obtén información para trabajar",
        "aipictureAnalysisDesc":"Analiza imágenes fácilmente con Edraw AI",
        "aiDrawDesc": "Dibujo con IA",
        "newEmpty": "Nuevo {label} en blanco",
        "recommendClass": "Recomendado",
        "more": "Más",
        "clone": "Usar plantilla",
        "sort": "Cambiar orden",
        "input": "Si prega di immettere"
      },
      "it": {
        "free": "Gratis",
        "vipFree": "Premium",
        "newFile": "File Senza Nome",
        "space": "Spazio di archiviazione insufficiente. Si prega di eliminare dei file o di eseguire l'upgrade alla versione premium.",
        "notTem": "Non sono ancora presenti modelli per questa categoria.",
        "create": "Creazione file in corso. Si prega di riprovare.",
        "openTips": "Apertura file in corso. Si prega di riprovare.",
        "search": "Cerca",
        "searchResult": "risultato della ricerca",
        "recent": "Recente",
        "recommend": "Consigliato",
        "classify": "Classificazione",
        "moreTemplate": "Altri Modelli",
        "createNow": "Crea ora",
        "template": "Modelli",
        "inputSearch": "Cerca i disegni che ti servono",
        "searchHistory": "Cronologia di ricerca",
        "clearHistory": "Cancella cronologia",
        "moreTemplate": "Altre forme",
        "recommendTemp": "Modelli consigliati",
        "blank": "Bianco",
        "file": "File",
        "aiTemplateTitle": "Strumenti AI",
        "aiTemplateDesc": "Utilizzo dell'intelligenza artificiale per accelerare il lavoro",
        "aiTemplateDesc1": "Accelera il flusso di lavoro con Edraw AI",
        "aiflowchart": "Diagramma di flusso AI",
        "aimindmap": "Mappa mentale AI",
        "pictureAnalysis": "Analisi immagine AI",
        "aicreateflowchartDesc": "Apri una chat per creare un diagramma di flusso in un istante ",
        "aiQA": "Chat AI",
        "aiDraw": "Disegno AI",
        "aicreatemindmapDesc": "Crea una mappa mentale con un clic ",
        "aiQADesc": "Apri una chat con Edraw AI per ottenere informazioni sul lavoro",
        "aipictureAnalysisDesc":"Analizza facilmente la tua immagine con Edraw AI",
        "aiDrawDesc": "Disegno AI",
        "newEmpty": "Nuovo {label} vuoto",
        "recommendClass": "Consigliato",
        "more": "Altro",
        "clone": "Usa il modello",
        "sort": "Riorganizza ordine",
        "input": "per favore inserisci"
      },
      "pt": {
        "free": "Gratuito",
        "vipFree": "Premium",
        "newFile": "Ficheiro Sem Nome",
        "space": "Espaço de armazenamento insuficiente, eliminar ficheiros ou fazer upgrade para a versão premium para resolver o problema.",
        "notTem": "Ainda não existe modelo para esta categoria.",
        "create": "Criando ficheiro, por favor, tentar mais tarde.",
        "openTips": "Abrindo ficheiro, por favor, tentar mais tarde.",
        "search": "Pesquisar",
        "searchResult": "resultado da pesquisa",
        "recent": "Recente",
        "recommend": "Recomendado",
        "classify": "Classificação",
        "moreTemplate": "Mais Modelos",
        "createNow": "Criar agora",
        "template": "Modelos",
        "inputSearch": "Pesquise os desenhos que deseja encontrar",
        "searchHistory": "Histórico de pesquisa",
        "clearHistory": "Limpar histórico",
        "moreTemplate": "Mais formas",
        "recommendTemp": "Modelos recomendados",
        "blank": "Em branco",
        "file": "Arquivo",
        "aiTemplateTitle": "Ferramentas de IA",
        "aiTemplateDesc": "Use a IA para otimizar seu trabalho",
        "aiTemplateDesc1": "Acelere seu fluxo de trabalho usando o Edraw AI",
        "aiflowchart": "Fluxograma de IA",
        "aimindmap": "Mapa de ideias de IA",
        "pictureAnalysis": "Análise de imagem por IA",
        "aicreateflowchartDesc": "Converse para criar um fluxograma instantaneamente ",
        "aiQA": "Chat por IA",
        "aiDraw": "Desenho por IA",
        "aicreatemindmapDesc": "Crie um mapa de ideias com um único clique  ",
        "aiQADesc": "Converse com o Edraw AI para obter insights sobre otrabalho",
        "aipictureAnalysisDesc":"Analise sua imagem facilmente com o Edraw AI",
        "aiDrawDesc": "Desenho por IA",
        "newEmpty": "Novo {label} em branco",
        "recommendClass": "Recomendado",
        "more": "Mais",
        "clone": "Usar modelo",
        "sort": "Reordenar",
        "input": "Por favor, inserir"
      },
      "tw": {
        "free": "免費",
        "vipFree": "Premium",
        "newFile": "未命名檔案",
        "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
        "notTem": "該分類下暫時還沒有模板",
        "create": "正在建立檔案中，請稍後再試",
        "openTips": "正在打開檔案中，請稍後再試",
        "search": "搜尋",
        "createNow": "立即新建",
        "template": "模板",
        "inputSearch": "搜尋您需要的繪圖",
        "searchHistory": "搜尋歷程記錄",
        "clearHistory": "清除歷程記錄",
        "moreTemplate": "更多圖形",
        "recommendTemp": "建議的範本",
         "blank": "空白",
        "file": "文件",
        "aiTemplateTitle": "AI 工具",
        "aiTemplateDesc": "運用 AI 加速您的工作",
        "aiTemplateDesc1": "運用 Edraw AI 加速您的工作流程",
        "aiflowchart": "AI 流程圖",
        "aimindmap": "AI 心智圖",
        "pictureAnalysis": "AI 圖片分析",
        "aicreateflowchartDesc": "透過聊天來即時建立流程圖",
        "aiQA": "AI 聊天",
        "aiDraw": "AI 繪圖",
        "aicreatemindmapDesc": "只要按一下即可建立心智圖 ",
        "aiQADesc": "與 Edraw AI 聊天以取得工作深入解析",
        "aipictureAnalysisDesc":"運用 Edraw AI 輕鬆分析您的圖片",
        "aiDrawDesc": "AI 繪圖",
        "newEmpty": "新建空白{label}",
        "recommendClass": "精选推荐",
        "more": "更多",
        "clone": "使用模板",
        "sort": "重新排列順序",
        "input": "請輸入"
      },
      "kr": {
        "free": "무료",
        "vipFree": "회원무료",
        "newFile": "이름이없는 파일",
        "space": "클라우드 공간이 상한에 도달했습니다. 파일을 삭제하거나 휴지통을 비우십시오.",
        "notTem": "현재 이 카테고리에는 템플릿이 없습니다.",
        "create": "파일을 만드는 중입니다. 나중에 다시 시도하세요~",
        "openTips": "파일을 여는 중입니다. 나중에 다시 시도하세요~",
        "search": "검색",
        "searchResult": "검색 결과",
        "recent": "최근",
        "recommend": "추천",
        "classify": "분류",
        "moreTemplate": "더 많은 템플릿",
        "createNow": "지금 만들기",
        "template": "템플릿",
        "clone": "템플릿 사용",
        "inputSearch": "필요한 그림 검색",
        "searchHistory": "검색 기록",
        "clearHistory": "기록 지우기",
        "moreTemplate": "더 많은 도형",
        "recommendTemp": "추천 템플릿",
        "blank": "공백",
        "file": "파일",
        "aiTemplateTitle": "AI 도구",
        "aiTemplateDesc": "AI를 사용하여 작업을 가속화하세요. ",
        "aiTemplateDesc1": "Edraw AI를 사용해 작업 흐름을 가속화하세요.",
        "aiflowchart": "AI 순서도",
        "aimindmap": "AI 마인드맵",
        "pictureAnalysis": "AI 사진 분석",
        "aicreateflowchartDesc": "채팅하여 순서도 즉시 생성 ",
        "aiQA": "AI 채팅",
        "aiDraw": "AI 드로잉",
        "aicreatemindmapDesc": "클릭 한 번으로 마인드맵 생성  ",
        "aiQADesc": "Edraw AI와의 채팅으로 업무 통찰력 얻기",
        "aipictureAnalysisDesc":"Edraw AI로 간편하게 사진 분석",
        "aiDrawDesc": "AI 드로잉",
        "newEmpty": "新建空白{label}",
        "recommendClass": "추천",
        "more": "更多",
        "clone": "템플릿 사용",
        "sort": "순서 재정렬",
        "input": "입력하세요"
      },
      "id": {
        "free": "Gratis",
        "vipFree": "VIP Gratis",
        "newFile": "File Tanpa Nama",
        "space": "Ruang penyimpanan tidak cukup. Hapus file atau tingkatkan ke versi premium untuk mengatasinya.",
        "notTem": "Belum ada templat untuk kategori ini.",
        "create": "Membuat file. Coba lagi nanti.",
        "openTips": "Membuka file. Coba lagi nanti.",
        "search": "Cari",
        "searchResult": "searchResult",
        "recent": "Terbaru",
        "recommend": "Disarankan",
        "classify": "Klasifikasi",
        "moreTemplate": "Templat Lainnya",
        "createNow": "Buat Baru",
        "clone": "Gunakan Templat",
        "newEmpty": "{label} Kosong Baru",
        "recommendClass": "Rekomendasi",
        "more": "Lainnya"
      }
    }
    </i18n>
